<style>
.el-message-box__wrapper {
	background-color: rgb(184, 210, 229, 0.6);
}
</style>
<style scoped lang="less">
.dropdown-enter-active {
	animation: expand-contract 0.4s ease;
}

.dropdown-leave-active {
	animation: expand-contract 0.4s ease reverse;
}

// 收缩展开动画
@keyframes expand-contract {
	0% {
		overflow: hidden;
		opacity: 0;
		max-height: 0;
	}

	100% {
		max-height: 300px; // 大于等于下拉菜单的高度
		opacity: 1;
	}
}

// 菜单内容变化动画
@keyframes menu {
	0% {
		opacity: 0;
		transform: translateX(50%);
	}

	100% {
		opacity: 1;
		transform: translateX(0%);
	}
}

@media (max-width: 767.98px) {
	.app-header .navbar-nav {
		border-top: none !important;
		background: linear-gradient(to right, #2e61bf, #60c363);
	}
}

.app-header {
	height: 60px !important;
	/* border-bottom: 5px solid #44BBF0; */
	background: linear-gradient(to right, #2e61bf, #60c363);
}

.dropdown-item {
	color: #000 !important;
	cursor: pointer;
}

.media-heading {
	color: #000 !important;
}

.media-body {
	overflow: hidden;
	overflow: ellipsis;
}

.yd:hover {
	background: #fff !important;
}

.navbarse {
	.fontipt {
		width: 100%;
		padding: 0.6rem 0.8rem !important;
		font-size: 1rem;

		border-radius: 2px;
		background: rgba(255, 255, 255, 0.2);
		box-sizing: border-box;
		// border-top-right-radius: 10px;
		// border-top-right-radius: 16px;
		// border-bottom-right-radius: 16px;
	}

	/deep/ .app-header .navbar-form .btn-search {
		position: inherit !important;
	}

	.fontipt::placeholder {
		color: #ebebeb !important;
	}

	/deep/ .navbar-form {
		margin: 9px 0 9px 5% !important;
		width: 100% !important;
	}

	button {
		color: #fff;
		border: 1px;
		border-top-right-radius: 16px;
		border-bottom-right-radius: 16px;
		border-top-left-radius: 1px;
		border-bottom-left-radius: 1px;
	}
}

.downsnumne {
	width: 94%;
	background-color: rgba(255, 255, 255, 1);
	position: absolute;
	top: 100%;
	height: 400px;
	padding: 0.4rem 2rem;

	overflow-y: scroll;
	z-index: 999;
	border: 1px solid #ccc;
	box-sizing: border-box;

	& a:hover {
		color: #11821f !important;
		font-weight: 700;
	}

	div {
		font-size: 0.8rem;
		margin: 0.4rem 0;
		color: #333;
	}

	.titles {
		font-size: 1rem;
	}
}

/deep/ .el-dropdown {
	margin-right: 16px;
}
</style>

<template>
	<div>
		<!-- BEGIN #header -->
		<div id="header" class="app-header" v-bind:class="{ 'app-header-inverse': appOptions.appHeaderInverse }">
			<!-- BEGIN navbar-header -->
			<div class="navbar-header">
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarEndMobile" v-if="appOptions.appSidebarTwo">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<router-link to="/homesview/homesview" class="navbar-brand">
					<!-- <span class="navbar-logo"></span> -->
					<img src="./../../images/logo1.png" alt="" style="margin-right: 10px;" />
					<b style="letter-spacing: 2px;">智慧实训管理平台</b>
				</router-link>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleTopMenuMobile" v-if="appOptions.appTopMenu && !appOptions.appSidebarNone">
					<span class="fa-stack fa-lg text-inverse">
						<i class="far fa-square fa-stack-2x"></i>
						<i class="fa fa-cog fa-stack-1x"></i>
					</span>
				</button>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleTopMenuMobile" v-if="appOptions.appTopMenu && appOptions.appSidebarNone">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleHeaderMegaMenuMobile" v-if="appOptions.appHeaderMegaMenu">
					<span class="fa-stack fa-lg text-inverse m-t-2">
						<i class="far fa-square fa-stack-2x"></i>
						<i class="fa fa-cog fa-stack-1x"></i>
					</span>
				</button>
				<button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarMobile" v-if="!appOptions.appSidebarNone">
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
			</div>
			<!-- END navbar-header -->

			<!-- BEGIN header-nav -->
			<div class="navbar-nav navbarse">
				<header-mega-menu v-if="appOptions.appHeaderMegaMenu"></header-mega-menu>
				<div class="navbar-item navbar-form">
					<form action="" method="POST" name="search">
						<div class="form-group fontipts">
							<input
								@input="inputshrach()"
								style="color: #000;"
								maxlength="20"
								type="text"
								class="fontipt"
								@click.stop="doubleipt($event)"
								placeholder="搜索菜单"
								v-model="numnas"
								id="fontipt"
							/>
						</div>
					</form>
					<transition name="dropdown">
						<div class="downsnumne" id="downsnumne" v-show="allshow">
							<div class="titles" v-if="isallshows == 0" v-for="(item, index) in users.UserMenuList" :key="index">
								<p v-if="item.children.length > 0" style="color:#bebebe;">{{ item.title }}</p>
								<router-link :to="item.path" v-if="item.children.length == 0">{{ item.title }}</router-link>
								<div v-if="item.children.length > 0" style="margin-left: 2rem;" v-for="(ite, idx) in item.children" :key="idx">
									<router-link :to="ite.path">-- {{ ite.title }}</router-link>
								</div>
							</div>

							<div class="titles" v-if="isallshows == 1" v-for="(item, index) in this.numlists" :key="index">
								<p v-if="item.MenuParent.length > 0" style="color:#bebebe;">{{ item.mu_name_cn }}</p>
								<router-link :to="item.mu_menuPath" v-if="item.MenuParent.length == 0">{{ item.mu_name_cn }}</router-link>
								<div v-if="item.MenuParent.length > 0" style="margin-left: 1rem;" v-for="(ite, idx) in item.MenuParent" :key="idx">
									<router-link :to="ite.mu_menuPath">-- {{ ite.mu_name_cn }}</router-link>
								</div>
							</div>
						</div>
					</transition>
				</div>
				<!-- <p style="width: 5%;text-align: center;font-size: 1rem;border-radius: 20px;background-color: #F3AEC3;color: #fff;" @click="godatas()">数据墙</p> -->

				<!-- <el-dropdown>
				      <span >
				        下拉菜单<i class="el-icon-arrow-down el-icon--right"></i>
				      </span>
				      <el-dropdown-menu slot="dropdown">
				        <el-dropdown-item icon="el-icon-plus">黄金糕</el-dropdown-item>
				        <el-dropdown-item icon="el-icon-circle-plus">狮子头</el-dropdown-item>
				        <el-dropdown-item icon="el-icon-circle-plus-outline">螺蛳粉</el-dropdown-item>
				        <el-dropdown-item icon="el-icon-check">双皮奶</el-dropdown-item>
				        <el-dropdown-item icon="el-icon-circle-check">蚵仔煎</el-dropdown-item>
				      </el-dropdown-menu>
				    </el-dropdown> -->

				<el-dropdown trigger="click">
					<template class="el-dropdown-link">
						<div style="display: flex;align-items:center;color: #fff;">
							<img style="width: 30px;height: 30px;border-radius: 50%;" v-if="users.ui_photoPath !== null" :src="users.ui_photoPath" alt="" />
							<img v-else src="./../../images/header.png" alt="" style="width: 30px;height: 30px;border-radius: 50%;" />
							<p :title="users.ui_realName" class="d-none d-md-inline" style="margin-left: 10px; display: flex;align-items: center;">{{ users.ui_realName }}</p>
							<b class="caret"></b>
						</div>
					</template>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item><p class="dropdown-item" @click="gouseredit()">编辑信息</p></el-dropdown-item>
						<el-dropdown-item><p class="dropdown-item" @click="gocourse()">回引导页</p></el-dropdown-item>
						<el-dropdown-item><a @click="deleteuser()" class="dropdown-item">退出登录</a></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<div class="navbar-divider d-none d-md-block" v-if="appOptions.appSidebarTwo"></div>
				<div class="navbar-item d-none d-md-block" v-if="appOptions.appSidebarTwo">
					<a href="javascript:;" v-on:click="toggleSidebarEnd" class="navbar-link icon"><i class="fa fa-th"></i></a>
				</div>
			</div>
			<!-- end header navigation right -->
		</div>
		<!-- end #header -->
	</div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue';
import HeaderMegaMenu from './HeaderMegaMenu.vue';
import { getUserSingle, GetMenuListByContainsName } from '@/request/api/mange/mange.js';
import $ from 'jquery';

export default {
	name: 'Header',
	components: {
		HeaderMegaMenu
	},
	data() {
		return {
			appOptions: AppOptions,
			users: {},
			allshow: false,
			numnas: '',
			isallshows: 0,
			numlists: []
		};
	},
	created() {},
	beforeMount() {},
	mounted() {
		let userinfo = JSON.parse(localStorage.getItem('userss'));
		if (userinfo) {
			this.users = userinfo;
		} else {
			this.getlogins();
		}
	},
	methods: {
		getlogins() {
			if (this.$cookie.get('Token') && this.$cookie.get('Token').indexOf('ui_guid') > 0) {
				// 如果cookie有token且有id就从外域拿
				let uiguid = this.$cookie
					.get('Token')
					.split('&')[1]
					.split('=')[1];

				getUserSingle(uiguid).then(re => {
					if (re.data.code == -2) {
						localStorage.clear();
						// this.$cookie.clear();
						return;
					}

					if (re.data.code == -1) {
						// console.log("无权限")
						// this.$router.push("/user/logins")
					} else {
						this.users = re.data.data;
						localStorage.setItem('userss', JSON.stringify(re.data.data));
					}
				});
			} else if (localStorage.getItem('uiguid') && localStorage.getItem('token')) {
				getUserSingle(localStorage.getItem('uiguid'))
					.then(res => {
						// console.log(res,'获取当前对象')
						if (res.data.code == -2) {
							localStorage.clear();
							// this.$cookie.clear();
							return;
						}

						if (res.data.code == -1) {
							// this.$router.push("/user/logins")
							return;
						} else if (res.data.code == -2) {
							localStorage.clear();
						} else {
							this.users = res.data.data;
							localStorage.setItem('userss', JSON.stringify(res.data.data));
						}
					})
					.catch(err => {
						// console.log(err,"错误对象")
						this.$router.push('/user/logins');
					});
			}
		},

		validate(str) {
			var reg = new RegExp('^[0-9]{6}$');
			if (!reg.test(str)) {
				return false;
			} else {
				return true;
			}
		},
		godatas() {
			var siguid = localStorage.getItem('siguid');
			window.open('http://www.hngtsd.net/databig/index.html?siguid=' + siguid);
		},
		gocourse() {
			this.$router.push('/inits');
		},
		inputshrach() {
			this.isallshows = 1;
			GetMenuListByContainsName(this.numnas).then(res => {
				if (res.data.code == 1) {
					this.numlists = res.data.data;
				}
			});
		},
		gouseredit() {
			this.$router.push('/usercenter/usermessage');
		},

		// 获取用户信息
		getuservs() {
			getUserSingle(localStorage.getItem('uiguid')).then(res => {
				this.users = res.data.data;
				// console.log(res,"获取当前用户")
				// this.$router.push(this.users.UserMenuList[0].path)
			});
		},

		// 退出登录
		deleteuser() {
			let pasad = '';
			let name = '';
			if (this.$cookie.get('/%name/%')) {
				pasad = this.$cookie.get('/%password/%');
				name = this.$cookie.get('/%name/%');
				this.$cookie.set('/%password/%', pasad);
				this.$cookie.set('/%name/%', name);
			}
			localStorage.removeItem('token');
			localStorage.removeItem('siguid');
			localStorage.removeItem('uiguid');
			this.$cookie.remove('allbtnlist');
			this.$cookie.remove('/%sxtrguid/%');
			this.$cookie.remove('sxsi_guid');
			this.$cookie.remove('Token');
			this.$cookie.remove('Token');
			this.delCookie();

			this.$router.push({
				name: '登录'
			});
		},

		delCookie() {
			var keys = document.cookie.match(/[^ =;]+(?==)/g);
			if (keys) {
				for (var i = keys.length; i--; ) {
					document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString(); // 清除当前域名下的,例如：m.ratingdog.cn
					document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString(); // 清除当前域名下的，例如 .m.ratingdog.cn
					document.cookie = keys[i] + '=0;path=/;domain=.test.com;expires=' + new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .ratingdog.cn
				}
			}
		},

		// 鼠标点击清空文字
		doubleipt(e) {
			console.log(e.target);
			// e.target.placeholder = ""
			// e.target.style.background = "#fff"
			// e.target.nextSibling.style.background = "rgba(255, 255, 255, 0.3);"
			// e.target.nextSibling.style.color = "#000"
			this.allshow = true;
			$('#downsnumne').outerWidth($('#fontipt').outerWidth());
			console.log($('#downsnumne').outerWidth(), $('#fontipt').outerWidth());
		},

		toggleSidebarMobile() {
			this.appOptions.appSidebarMobileToggled = !this.appOptions.appSidebarMobileToggled;
		},
		toggleSidebarEnd() {
			this.appOptions.appSidebarEndToggled = !this.appOptions.appSidebarEndToggled;
		},
		toggleSidebarEndMobile() {
			this.appOptions.appSidebarEndMobileToggled = !this.appOptions.appSidebarEndMobileToggled;
		},
		toggleTopMenuMobile() {
			this.appOptions.appTopMenuMobileToggled = !this.appOptions.appTopMenuMobileToggled;
		},
		toggleHeaderMegaMenuMobile() {
			this.appOptions.appHeaderMegaMenuMobileToggled = !this.appOptions.appHeaderMegaMenuMobileToggled;
		},
		checkForm: function(e) {
			e.preventDefault();
			this.$router.push({
				path: '/extra/search'
			});
		}
	}
};
</script>
